import React, { Component } from 'react';
import { components } from 'common';
const { If } = components;
import { IAiDimensionData } from '../../../../types';
import { LinearScore } from '../linearScore/linearScore';
import { dimensionCompare, columns } from '../../aiReportUtil';
import './linearChart.scss';

interface ILinearChartProps {
    dimensions: IAiDimensionData;
    fullScore: number;
    aiVoiceCheckSwitch?: number;
}

/**
 * 一维、二维时显示的线性图
 */
export default class LinearChart extends Component<ILinearChartProps, {}> {
    public renderLinearScore = (dimensionKeys: string[], index: number) => {
        const { dimensions, aiVoiceCheckSwitch, fullScore } = this.props;
        const dimensionKey = dimensionKeys[index];
        if (0 === aiVoiceCheckSwitch && ('speed' === dimensionKey || 'smooth' === dimensionKey)) {
            return;
        }
        return (
            <If condition={dimensionKeys.length > index}>
                <>
                    <p className="linear-title">{columns[dimensionKey]}</p>
                    <LinearScore score={dimensions[dimensionKey]} fullScore={fullScore}/>
                </>
            </If>
        );
    };

    public render() {
        const { dimensions } = this.props;
        const dimensionKeys = Object.keys(dimensions).sort(dimensionCompare);
        return (
            <div className="linear-chart">
                {this.renderLinearScore(dimensionKeys, 0)}
                {this.renderLinearScore(dimensionKeys, 1)}
            </div>
        );
    }
}
